import { onValue, ref, remove, set, update,get,child,getDatabase,orderByChild} from 'firebase/database';
import './App.css';
import { db } from './firebase';
import { useState,useEffect } from 'react';
import { uid } from 'uid';
function App() {
	const [name,setName]=useState("")
	const [message,setMessage]=useState("")
	const [datas,setDatas]=useState([])
	const [tempUuid,setTempUuid]=useState("")
	const [ip,setIp]=useState("")

	const handleSelect = (event) => {
		event.preventDefault();
	  };
	//write
	const writeDB=()=>{
		const uuid=Date.now()
		var today = new Date();
		var year = today.getFullYear();
		var month = ('0' + (today.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1，并确保为两位数
		var day = ('0' + today.getDate()).slice(-2); // 确保日期为两位数
		var hours = ('0' + today.getHours()).slice(-2);
		var minutes = ('0' + today.getMinutes()).slice(-2);
		var currentTime = year + '/' + month + '/' + day + ' ' + hours + ':' + minutes;
		if(name!=''){
			set(ref(db,`/${uuid}`),{
				badge:"",
				name,
				uuid,
				message,
				ip,
				currentTime,
				response:""
			})
		}else{
			alert("must include data!")
		}
		
		setName("")
	}
	//read
	useEffect(()=>{
		fetch('https://api.ipify.org?format=json')
		.then(response => response.json())
		.then(data => {
			var clientIP = data.ip;
			// console.log(clientIP);
			setIp(clientIP)
		});
		onValue(ref(db),(snapshot)=>{
			setDatas([])
			const data = snapshot.val()
			
			
			//console.log(data)
			if(data!==null && data !=""){
				Object.values(data).map((element)=>{
					// console.log(element)
					setDatas((oldArray)=>[...oldArray,element])
				})
				// setDatas(()=>{Array.from(datas).sort((a, b) => a[1] - b[1]);})
				console.log(datas)
				datas.sort((a, b) => a.currentTime - b.currentTime)
				console.log(datas)
			}
			
		})
	},[])
	return (
		<div className="App">
			<h1 className='title'>APCS 暑期營隊留言板</h1>
			<p>留言板為公開場合，請注意用詞，老師看到留言後都會盡快回覆！</p>
			<div className='form'>
				<input type='hidden'/>
				<input className='name' type='text' placeholder='輸入姓名' defaultValue={""} onChange={(e)=>{setName(e.target.value);}}/>
				<br/>
				<textarea className='message'type='text' rows={10} placeholder='請輸入訊息' onChange={(e)=>{setMessage(e.target.value);}} defaultValue={""}/>
				<br/>
				<button onClick={writeDB}>送出</button>
			</div>
			<br/>
			<div className='board'>
			{datas.map((element)=>{
					return(
						// <DataView key={element.uuid} data={element.todo} uid={element.uuid}></DataView>
						<div className="dataView" key={"dataView_"+element.uuid}>
							<input hidden key={element.uuid} id={element.uuid} value={element.uuid} readOnly/>
							<div className='dataView_upper'>
								<p className='adminBadge' key={"badge_"+element.uuid}>{element.badge}</p>
								<hr/>
								<div className='dataView_div' key={"name_"+element.uuid}>{element.name}</div>
								<div className='dataView_div' key={"time_"+element.uuid}>發佈時間：{element.currentTime}</div>
								<div className='dataView_div' key={"ip_"+element.uuid}>發佈IP：{element.ip}</div>
								<div className='message_data' key={"value_"+element.uuid}>{element.message}</div>
								<textarea className='dataView_div dataView_div_res' onSelect={handleSelect} rows={5} key={"res_"+element.uuid}  disabled defaultValue={element.response}></textarea>
							</div>
							{/* <button className="upd_btn" key={"upd_"+element.uuid} onClick={()=>handleUpdate(element)} >update</button>
							<button className="del_btn" key={"del_"+element.uuid} onClick={()=>handleDelete(element)}>delete</button> */}
						</div>
					)
				})}
			</div>
		</div>
	);
}

export default App;
